var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0",
      attrs: { id: "verify-match-step-right-part" }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { id: "verify-match-step-right-part-inside" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center small-text"
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("verify.match.page.search.done")))
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "card-plate mb-3" }, [
              _vm._v("\n        " + _vm._s(_vm.identifier) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  ref: "addressInput",
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.address.invalidFeedback,
                    label: _vm.$t("annonce.place.robbery"),
                    state: _vm.address.state,
                    "label-for": "address-input"
                  }
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("GmapAutocomplete", {
                        ref: "addressAutocomplete",
                        staticClass: "form-control",
                        attrs: {
                          id: "address-input",
                          options: _vm.autocompleteOptions,
                          required: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.removeInvalidFeedback("address")
                          },
                          input: _vm.handleStartAddressInput,
                          place_changed: _vm.handleAddressSelect
                        },
                        model: {
                          value: _vm.address.value,
                          callback: function($$v) {
                            _vm.$set(_vm.address, "value", $$v)
                          },
                          expression: "address.value"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-input-group-append", [
                        _c(
                          "div",
                          {
                            class:
                              _vm.locationPermission === "granted"
                                ? "custom-append-locate cursor-pointer"
                                : "custom-append-locate-disabled",
                            attrs: { id: "pin-locate" },
                            on: { click: _vm.locateUser }
                          },
                          [
                            _c("i", {
                              staticClass: "ph-custom ph-map-pin",
                              class:
                                _vm.locationPermission === "granted"
                                  ? "main-color"
                                  : "text-disabled"
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.locationPermission !== "granted"
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                placement: "bottom",
                                target: "pin-locate",
                                triggers: "hover"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("autorisation.geolocation.tooltip")
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  ref: "vehicleTypeInput",
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.vehicleType.invalidFeedback,
                    label: _vm.$t("verify.match.vehicle.type"),
                    state: _vm.vehicleType.state,
                    "label-for": "vehicleType-input"
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        id: "vehicleType-input",
                        state: _vm.vehicleType.state,
                        required: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.updateVehicleTypeData()
                          _vm.removeInvalidFeedback("vehicleType")
                        }
                      },
                      model: {
                        value: _vm.vehicleType.value,
                        callback: function($$v) {
                          _vm.$set(_vm.vehicleType, "value", $$v)
                        },
                        expression: "vehicleType.value"
                      }
                    },
                    _vm._l(_vm.vehicleTypes, function(vehicleType) {
                      return _c(
                        "option",
                        { domProps: { value: vehicleType.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(vehicleType.name) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("AutocompleteField", {
            key: "brandAutocomplete",
            ref: "brandInput",
            staticClass: "col-12 pl-0 pr-0 mb-1",
            attrs: {
              "initial-value": _vm.brand.value,
              "input-label": _vm.$t("VehicleBrand"),
              invalidFeedback: _vm.brand.invalidFeedback,
              items: _vm.brands,
              "need-create-if-empty": false,
              "ready-to-set-initial-value": _vm.readyToSetInitialBrand,
              state: _vm.brand.state,
              "input-class": "small-text mb-4",
              "input-id": "brand-input"
            },
            on: { newSelectedValue: _vm.getSelectedBrand },
            model: {
              value: _vm.brand.value,
              callback: function($$v) {
                _vm.$set(_vm.brand, "value", $$v)
              },
              expression: "brand.value"
            }
          }),
          _vm._v(" "),
          _c("AutocompleteField", {
            key: "modelAutocomplete",
            ref: "modelInput",
            staticClass: "col-12 pl-0 pr-0 mb-1",
            attrs: {
              "initial-value": _vm.model.value,
              "input-label": _vm.$t("VehicleModel"),
              invalidFeedback: _vm.model.invalidFeedback,
              items: _vm.models,
              "need-create-if-empty": false,
              "ready-to-set-initial-value": _vm.readyToSetInitialModel,
              state: _vm.model.state,
              "input-class": "small-text mb-4",
              "input-id": "model-input"
            },
            on: { newSelectedValue: _vm.getSelectedModel },
            model: {
              value: _vm.model.value,
              callback: function($$v) {
                _vm.$set(_vm.model, "value", $$v)
              },
              expression: "model.value"
            }
          }),
          _vm._v(" "),
          _vm.isLicensedAndNeedVIN
            ? _c(
                "div",
                { staticClass: "col-12 pl-0 pr-0 mb-1" },
                [
                  _c(
                    "b-form-group",
                    {
                      ref: "vinInput",
                      staticClass: "small-text",
                      attrs: {
                        "invalid-feedback": _vm.VIN.invalidFeedback,
                        label: _vm.$t("annonce.vehicle.VIN"),
                        "label-for": "VIN-input"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "VIN-input",
                          formatter: _vm.IdentifierUtils.formatVin,
                          state: _vm.VIN.state
                        },
                        on: {
                          change: function($event) {
                            _vm.setMatch
                            _vm.removeInvalidFeedback("VIN")
                          }
                        },
                        model: {
                          value: _vm.VIN.value,
                          callback: function($$v) {
                            _vm.$set(_vm.VIN, "value", $$v)
                          },
                          expression: "VIN.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  ref: "colorInput",
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.color.invalidFeedback,
                    label: _vm.$t("annonce.vehicle.Color"),
                    state: _vm.color.state,
                    "label-for": "color-input"
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: {
                        id: "color-input",
                        state: _vm.color.state,
                        required: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.setMatch
                          _vm.removeInvalidFeedback("color")
                        }
                      },
                      model: {
                        value: _vm.color.value,
                        callback: function($$v) {
                          _vm.$set(_vm.color, "value", $$v)
                        },
                        expression: "color.value"
                      }
                    },
                    _vm._l(_vm.colors, function(color) {
                      return _c(
                        "option",
                        { domProps: { value: color.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(color.text)) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLicensedAndNeedVIN
            ? _c("AutocompleteField", {
                key: "modelFinishAutocomplete",
                ref: "modelFinishInput",
                staticClass: "col-12 pl-0 pr-0 mb-1",
                attrs: {
                  "initial-value": _vm.modelFinish.value,
                  "input-label":
                    _vm.$t("vehicleModel.Finish") +
                    " " +
                    _vm.$t("verify.match.optional"),
                  invalidFeedback: _vm.modelFinish.invalidFeedback,
                  items: _vm.modelFinishes,
                  "label-is-html": true,
                  "need-create-if-empty": false,
                  "ready-to-set-initial-value":
                    _vm.readyToSetInitialModelFinish,
                  state: _vm.modelFinish.state,
                  "input-class": "small-text mb-4",
                  "input-id": "modelFinish-input"
                },
                on: { newSelectedValue: _vm.getSelectedModelFinish },
                model: {
                  value: _vm.modelFinish.value,
                  callback: function($$v) {
                    _vm.$set(_vm.modelFinish, "value", $$v)
                  },
                  expression: "modelFinish.value"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  ref: "energyInput",
                  staticClass: "small-text",
                  attrs: {
                    "invalid-feedback": _vm.energy.invalidFeedback,
                    label:
                      _vm.$t("annonce.vehicle.Energy") +
                      " " +
                      _vm.$t("verify.match.optional"),
                    state: _vm.energy.state,
                    "label-for": "energy-input"
                  }
                },
                [
                  _c(
                    "b-form-select",
                    {
                      attrs: { id: "energy-input", state: _vm.energy.state },
                      on: {
                        change: function($event) {
                          _vm.setMatch
                          _vm.removeInvalidFeedback("energy")
                        }
                      },
                      model: {
                        value: _vm.energy.value,
                        callback: function($$v) {
                          _vm.$set(_vm.energy, "value", $$v)
                        },
                        expression: "energy.value"
                      }
                    },
                    _vm._l(_vm.energies, function(energy) {
                      return _c(
                        "option",
                        { domProps: { value: energy.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(energy.text)) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  ref: "descriptionInput",
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.description"),
                    "label-for": "description-vehicle-input"
                  }
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "description-vehicle-input",
                      placeholder: _vm.$t(
                        "verify.match.page.description.placeholder"
                      ),
                      state: _vm.description.state
                    },
                    on: { change: _vm.setMatch },
                    model: {
                      value: _vm.description.value,
                      callback: function($$v) {
                        _vm.$set(_vm.description, "value", $$v)
                      },
                      expression: "description.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98aee584", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98aee584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/VerifyMatchStep2.vue
// module id = bR2l
// module chunks = 0